window.$ = window.jQuery = require('jquery');
const WOW  = require('wow.js');
window.wow = new WOW({
    live: false
});
require('bootstrap'); // The CSS library
